<i18n>
{
  "fr": {
    "label": "modèles disponibles"
  }
}
</i18n>

<template>
  <div class="listing-filters">
    <div class="listing-filters__inner">
      <h2 class="listing-filters__available-models">
        <span class="listing-filters__available-models-number">
          {{ nbModels }}
        </span>
        {{ $t('label') }}
      </h2>

      <div class="listing-filters__list">
        <form
          ref="listing-filters-form-ref"
          :action="url"
          class="listing-filters__form"
          method="POST"
        >
          <input type="hidden" name="_token" :value="csrf" />

          <div class="listing-filters__row">
            <div class="listing-filters__form-select">
              <ListingSelect
                v-if="filters"
                :items="cups"
                name="filters[size]"
                placeholder-text="Tous les types"
                @change="$refs['listing-filters-form-ref'].submit()"
              />
            </div>
            <div
              class="listing-filters__form-select listing-filters__form-select--hide-on-mobile"
            >
              <ListingSelect
                :items="categories"
                name="category"
                placeholder-text="Choisir une catégorie"
                @change="$refs['listing-filters-form-ref'].submit()"
              />
            </div>
          </div>

          <div class="listing-filters__row">
            <div
              v-if="subCategories.length > 0"
              class="listing-filters__form-select"
            >
              <ListingSelect
                :items="subCategories"
                name="subCategory"
                placeholder-text="Toutes les sous catégories"
                @change="$refs['listing-filters-form-ref'].submit()"
              />
            </div>
            <div
              class="listing-filters__form-select listing-filters__form-select--hide-on-mobile"
            >
              <ListingSelect
                v-if="filters"
                :items="sorts"
                name="orderBy"
                placeholder-text="Trier par"
                @change="$refs['listing-filters-form-ref'].submit()"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ListingSelect from './ListingSelect';

export default {
  name: 'ListingFilters',
  components: { ListingSelect },
  props: {
    url: {
      type: String,
      default: '',
    },
    nbModels: {
      type: Number,
      default: 0,
    },
    cups: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    subCategories: {
      type: Array,
      default: () => [],
    },
    sorts: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Boolean,
    },
  },
  data() {
    return {
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
    };
  },
};
</script>

<style scoped lang="scss">
.listing-filters {
  padding: 1.25em 0 0 0;
  margin-bottom: 2em;
  position: relative;

  @include breakpoint($breakpoint-m) {
    margin-bottom: 0;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    margin-bottom: 2em;

    @include breakpoint(68.125rem) {
      // 1090px
      padding: 0 2.25em;
      align-items: center;
      flex-direction: row;
    }

    @include breakpoint($breakpoint-xl) {
      gap: 3em;
      padding: 0 6.25em;
    }
  }

  &__available-models {
    font-size: 1.5625rem;
    font-family: 'BigShoulders', sans-serif;
    text-transform: uppercase;
    font-weight: bold;
    color: $color-blue-persian;
    text-align: center;
    margin-bottom: 0;

    @include breakpoint($breakpoint-m) {
      text-align: left;
    }
  }

  &__available-models-number {
    color: $color-red-amaranth;
    font-weight: 900;
  }

  &__form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.62em;
  }

  &__row {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.62em;
    flex-direction: row;
    align-items: center;
  }

  &__form-select {
    &--hide-on-mobile {
      display: none;

      @include breakpoint($breakpoint-s) {
        display: block;
      }
    }
  }
}
</style>
